import React from 'react';
import RLookUp from "./RLookUp";

const ModalOverlayRLookUp = (props) => {
  return <>
    <RLookUp
      {...props}
    />
  </>;
};

export default ModalOverlayRLookUp;
